import { Injectable } from '@angular/core';

@Injectable()

export class UserService {

  users = [
    {name: "Adam", username: "actaylor", password: "gocards"},
    {name: "Jorge", username: "jfelico", password: "server18"}
  ];

  Authenticate(username, password){
    let authenticated = false;
    let userInfo = null;

    for(let user of this.users){
      if(user.username == username && user.password == password){
        authenticated = true;
        userInfo = user;
      }
    }

    if(authenticated){
      return userInfo;
    } else {
    return false;
  }
  }

}



// WEBPACK FOOTER //
// ./src/app/user.service.ts